module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "statuspage-left.6c5cd6d4.svg";